/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest,
  TelegramAuthPhoneControllerVerifyCodeByPhoneMutationResponse,
  TelegramAuthPhoneControllerVerifyCodeByPhone400,
  TelegramAuthPhoneControllerVerifyCodeByPhone401,
  TelegramAuthPhoneControllerVerifyCodeByPhone403,
  TelegramAuthPhoneControllerVerifyCodeByPhone429,
} from '../types/TelegramAuthPhoneControllerVerifyCodeByPhone.ts';

function getTelegramAuthPhoneVerifyCodeByPhoneUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/phone/verify-code` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/phone/verify-code}
 */
export async function telegramAuthPhoneVerifyCodeByPhone(
  data: TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest,
  config: Partial<RequestConfig<TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthPhoneControllerVerifyCodeByPhoneMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthPhoneControllerVerifyCodeByPhone400
      | TelegramAuthPhoneControllerVerifyCodeByPhone401
      | TelegramAuthPhoneControllerVerifyCodeByPhone403
      | TelegramAuthPhoneControllerVerifyCodeByPhone429
    >,
    TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthPhoneVerifyCodeByPhoneUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
